import * as React from 'react';
import type { SVGProps } from 'react';
const EmployeeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="current"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.28562 7.68781C8.28562 5.58205 9.99267 3.875 12.0984 3.875C14.2042 3.875 15.9112 5.58205 15.9112 7.68781C15.9112 9.79356 14.2042 11.5006 12.0984 11.5006C9.99267 11.5006 8.28562 9.79356 8.28562 7.68781ZM12.0984 2C8.95714 2 6.41062 4.54652 6.41062 7.68781C6.41062 10.8291 8.95714 13.3756 12.0984 13.3756C15.2397 13.3756 17.7862 10.8291 17.7862 7.68781C17.7862 4.54652 15.2397 2 12.0984 2ZM12.0985 14.3508C7.26664 14.3508 3 17.5734 3 21.9387C3 22.4565 3.41973 22.8762 3.9375 22.8762C4.45527 22.8762 4.875 22.4565 4.875 21.9387C4.875 18.9506 7.92383 16.2258 12.0985 16.2258C16.2732 16.2258 19.322 18.9506 19.322 21.9387C19.322 22.4565 19.7418 22.8762 20.2596 22.8762C20.7773 22.8762 21.1971 22.4565 21.1971 21.9387C21.1971 17.5734 16.9304 14.3508 12.0985 14.3508Z"
      fill="currentColor"
    />
  </svg>
);
export default EmployeeIcon;
